import { add, remove } from "@fluorescent/dom";
import { shouldAnimate, delayOffset } from "@/lib/animation";

const selectors = {
  animationItems: ".quick-cart__items > *, .quick-cart__footer",
};

const classes = {
  animationRevealed: "animation--revealed",
};

export default node => {
  if (!shouldAnimate(node)) return;
  setup();

  // Setup delay offsets
  function setup() {
    delayOffset(node, [selectors.animationItems], 1);
  }

  // Trigger the reveal animation when the drawer is opened
  function open() {
    add(node, classes.animationRevealed);
  }

  // Reset the reveal animation when the drawer is closed
  function close() {
    remove(node, classes.animationRevealed);
  }

  return {
    setup,
    open,
    close,
  };
};
